/**
 * IntroPSESection — Bloc d'introduction PSE entre Hero et HowItWorks.
 *
 * Texte exact fourni par le client le 19/06/2026 (orientation PSE cacao).
 */
import React from 'react';
import { MapPin, Wallet, BarChart3 } from 'lucide-react';

const BENEFITS = [
  {
    icon: MapPin,
    title: 'Suivi terrain simple',
    desc: 'Parcelles, photos, GPS, validation.',
  },
  {
    icon: Wallet,
    title: 'Paiement transparent',
    desc: 'Déclenchement des primes PSE sur des critères clairs.',
  },
  {
    icon: BarChart3,
    title: 'Reporting crédible',
    desc: 'Tableaux de bord pour bailleurs, acheteurs et auditeurs.',
  },
];

const IntroPSESection = () => (
  <section className="bg-[#FAF9F6] py-16 md:py-20 px-4" data-testid="intro-pse-section">
    <div className="max-w-5xl mx-auto">
      <div className="text-center mb-12">
        <p className="text-base sm:text-lg text-[#374151] leading-relaxed max-w-3xl mx-auto">
          <strong className="text-[#1A3622]">GreenLink Agritech</strong> transforme les données terrain en preuves fiables pour les programmes de paiement pour services environnementaux.
        </p>
        <p className="text-base sm:text-lg text-[#374151] leading-relaxed max-w-3xl mx-auto mt-4">
          Notre plateforme permet de <strong>suivre les arbres</strong>, <strong>géolocaliser les parcelles</strong>, <strong>valider les lots</strong> et <strong>générer des rapports utiles</strong> pour les coopératives, les bailleurs et les exportateurs.
        </p>
      </div>

      <div className="grid sm:grid-cols-3 gap-4 sm:gap-6">
        {BENEFITS.map((b, i) => (
          <div
            key={i}
            className="bg-white border border-[#E5E5E0] rounded-xl p-6 hover:shadow-md hover:border-emerald-200 transition-all"
            data-testid={`intro-benefit-${i}`}
          >
            <div className="w-11 h-11 rounded-lg bg-emerald-50 border border-emerald-100 flex items-center justify-center mb-3">
              <b.icon className="h-5 w-5 text-emerald-700" />
            </div>
            <h3 className="text-base font-bold text-[#1A3622] mb-1.5">{b.title}</h3>
            <p className="text-sm text-[#374151] leading-relaxed">{b.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default IntroPSESection;
